import { render, staticRenderFns } from "./ContractorsTenderCard.vue?vue&type=template&id=0c621567&"
import script from "./ContractorsTenderCard.vue?vue&type=script&lang=js&"
export * from "./ContractorsTenderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports